import { BProgress } from './progress';
import { BProgressBar } from './progress-bar';
import { pluginFactory } from '../../utils/plugins';
var ProgressPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BProgress: BProgress,
    BProgressBar: BProgressBar
  }
});
export { ProgressPlugin, BProgress, BProgressBar };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/progress/index.js
// module id = 244
// module chunks = 0